<template>
    <v-layout align-start v-resize="getDimensions">
      <v-flex>
        <v-card class="overflow-hidden">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-dialog
                  ref="dialogFecha"
                  v-model="modalFechaInicial"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="mt-5"
                      outlined
                      type="date"
                      readonly
                      dense
                      ref="fechaInicial"
                      v-model="fechaInicial"
                      :rules="[$rules.requerido]"
                      @click="modalFecha = true"
                      :error-messages="errorMessages"
                      :label="'Fecha Inicial'"
                      v-bind="attrs"
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaInicial" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="cancelFechaInicial">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="setFechaInicial(date)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-dialog
                  ref="dialogFecha"
                  v-model="modalFechaFinal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      class="mt-5"
                      type="date"
                      readonly
                      dense
                      ref="fechaFinal"
                      v-model="fechaFinal"
                      :rules="[$rules.requerido]"
                      @click="modalFechaFinal = true"
                      :error-messages="errorMessages"
                      :label="'Fecha Final'"
                      v-bind="attrs"
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="fechaFinal" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="cancelFechaFinal">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="setFechaFinal(date)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete
                    outlined
                    dense
                    class="mt-5"
                    ref="sucursal"
                    v-model="sucursal"
                    :items="sucursalList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Sucursal"
                    required
                  ></v-autocomplete>
              </v-col>
            </v-row>
  
            <v-spacer></v-spacer>
  
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  large
                  @click="exportarExcel"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> fa-solid fa-file-excel </v-icon>
                </v-btn>
              </template>
              <span>Exportar a Excel</span>
            </v-tooltip>
          </v-app-bar>
  
          <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
            <v-data-table
              dense
              fixed-header
              :height="windowHeigth - (isMobile ? 128 : 200)"
              :headers="headers"
              :items="dtMedioPago"
              :hide-default-header="isMobile"
              mobile-breakpoint="0"
              show-group-by
              sort-by="codigo"
              :search="searchAll"
              class="elevation-1"
              :loading="dtMedioPagoLoad"
              loading-text="Cargando... Espere por favor"
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [-1, 100, 150, 200],
              }"
            >
              <template v-slot:[`item.monto`]="{ item }">
                <span class="font-weight-bold"
                  >{{ $formatoNumero(item.monto) }}
                </span>
              </template>
              <template v-slot:[`item.nombre_cliente`]="{ item }">
                <span class="font-weight-bold"
                  >({{ item.codigo }}) {{ item.nombre_cliente }}
                </span>
              </template>
  
              <template v-slot:[`item.fecha`]="{ item }">
                <span class="mx-5">{{ $formatoFechaSpanish(item.fecha) }} </span>
              </template>
  
              <template v-slot:no-data>
                <div>No se encontraron registros</div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      
        
      </v-flex>
    </v-layout>
  </template>
  
  <script>
  import axios from "axios";
  import dialogMixin from "../plugins/dialogs.js";
  
  export default {
    mixins: [dialogMixin],
    data() {
      return {
        //Declaración de variables globales
        user: this.$store.state.usuario.user,
        suc: this.$store.state.usuario.sucursal,
        //Declaración de arrays
        dtMedioPago: [],
        sucursalList: [],
        dtMedioPagoLoad: true,
        sucursal: "",
       
       
   
  
       
        color: "",
  
        fechaInicial: "",
        fechaFinal: "",
        errorMessages: "",
        //Declaración de variables de tabla
  
        
        headers: [
          {
            text: "Código Sac",
            value: "codigo_sac",
            align: "left",
            class: "primary font-weight-black white--text text-subtitle-2",
          },
          {
            text: "Usuario",
            value: "usuario",
            align: "left",
            class: "primary font-weight-black white--text text-subtitle-2",
          },
  
          {
            text: "Nombre Cliente",
            value: "nombre_cliente",
            align: "left",
            class: "primary font-weight-black white--text text-subtitle-2",
          },
          {
            text: "Sucursal",
            value: "sucursal",
            align: "left",
            class: "primary font-weight-black white--text text-subtitle-2",
          },
         
          {
            text: "Fecha",
            value: "fecha",
            align: "left",
            width: "130px",
            class: "primary font-weight-black white--text text-subtitle-2",
          },
          
          {
            text: "Monto",
            value: "monto",
            align: "right",
            class: "primary font-weight-black white--text text-subtitle-2",
          },{
            text: "Banco",
            value: "banco",
            align: "left",
            class: "primary font-weight-black white--text text-subtitle-2",
          },
          {
            text: "Bancarización",
            value: "bancarizacion",
            align: "left",
            class: "primary font-weight-black white--text text-subtitle-2",
          },
          
          {
            text: "Estado",
            value: "estado",
            align: "left",
            class: "primary font-weight-black white--text text-subtitle-2",
          },
        ],
  
        
        
  
      
        searchAll: "",
        
        //variables de errrores
        valida: 0,
        errorMessages: "",
        modalFechaInicial: false,
        modalFechaFinal: false,
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        error: "",
        //variables de tamaño de pantalla
        isMobile: false,
  
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
  
        windowWidth: window.innerWidth + this.auxWidth,
        windowHeigth: window.innerHeight,
      };
    },
  
   
   
    mounted() {
      this.getDimensions();
    },
  
    created() {
      this.$store.dispatch("actualizarTitulo", "Reporte de Bancarización");
      //establecemos la fecha inicial como el primer día del mes actual
      this.fechaInicial = this.$formatoFecha(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      );
      this.fechaFinal = this.$formatoFecha(new Date());
      this.sucursal = this.suc;
      this.listar();
      
      this.selectSucursal();
    },
    beforeDestroy() {
      this.$store.dispatch("actualizarTitulo", "");
    },
  
    methods: {
      cancelFechaInicial() {
          let me = this;  
          me.modalFechaInicial = false;
        },
      cancelFechaFinal() {
          let me = this;
          me.modalFechaFinal = false;
        },
      setFechaInicial() {
        let me = this;
        me.listar();
        me.modalFechaInicial = false;
      },
      setFechaFinal() {
        let me = this;
        me.listar();
        me.modalFechaFinal = false;
      },
  
   
      
      getDimensions() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.isMobile = this.width < 768;
      },
      listar() {
        let me = this;
        me.dtMedioPagoLoad = true;
        axios
          .get(
            "api/reportes/ListarReporteBancarizacion/" +
              me.fechaInicial +
              "/" +
              me.fechaFinal +
              "/" +
              me.sucursal
          )
          .then(function (response) {
            me.dtMedioPago = response.data;
            me.windowWidth = window.innerWidth + me.auxWidth;
            me.windowHeigth = window.innerHeight;
            me.dtMedioPagoLoad = false;
          })
          .catch(function (error) {
            me.dtMedioPagoLoad = false;
            me.$store.dispatch("setSnackbar", {
              text:
                error == "Error: Network Error"
                  ? "No se pudo conectar con el servidor"
                  : error,
              color: "error",
            });
          });
      },
      
      selectSucursal() {
      let me = this;
      me.dtUsuariosLoad = true;
      axios
        .get("api/clientes/SelectSucursal")
        .then(function (response) {
          me.sucursalList = response.data;          
        })
        .catch(function (error) {
          me.dtUsuariosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
  
      exportarExcel() {
        let me = this;
        me.loadingExcel = true;
        axios({
          url:
            "api/reportes/GenerarExcelBancarizacion/" +
            this.fechaInicial +
            "/" +
            this.fechaFinal,
          method: "GET",
          responseType: "blob",
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Reporte Metodo Pago - " + Date.now().toString() + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
          me.loadingExcel = false;
          me.$store.dispatch("setSnackbar", {
            text: "Excel generado exitosamente",
            color: "success",
          });
        });
      },
  
    
  
  
     
    },
  };
  </script>
  